import { useContext } from 'react';
import { ToastContext } from '../context';

export function useToastContext() {
  return useContext(ToastContext)!;
}
